import { useState } from "react";
import { FilterBuilderV2 } from "../../../../../components/filter/FilterBuilderV2";
import { FilterRecord } from "../../../../../components/filter/filter-constant";
import useActiveComponentCountController from "../../../../../components/filter/use-ActiveComponentCountController";
import { useProviderListV2 } from "../../../../../queries/use-provider-list-v2";
import { useLocationOptionsV2 } from "../../../../../queries/use-location-options-v2";
import { useDebounce } from "../../../../../hooks/use-debounce";
import { DEF_PAGINATION, getXtenantId } from "../../../../../utils/utils";
import {
  BillingReportFilterData,
  BILLING_STATUS_OPTIONS,
} from "./billing-report-constants";
import { REPORT_TIME_INTERVAL_OPTIONS } from "../appointment-scheduling/appointment-report-constants";

interface BillingReportFiltersProps {
  filters: BillingReportFilterData;
  onApply: (v: BillingReportFilterData) => void;
}

const BillingReportFilters = ({
  filters,
  onApply,
}: BillingReportFiltersProps) => {
  const [filterOpened, setFilterOpened] = useState(false);
  const [searchProviderKey, setSearchProviderKey] = useDebounce<string>("");
  const [searchLocationKey, setSearchLocationKey] = useDebounce<string>("");
  const xTenantId = getXtenantId();

  const { data: providersList } = useProviderListV2({
    pagination: DEF_PAGINATION,
    searchString: searchProviderKey,
    xTENANTID: xTenantId,
    status: true,
    enabled: filterOpened,
  });

  const { data: locationsList } = useLocationOptionsV2({
    searchString: searchLocationKey,
    xTENANTID: xTenantId,
    enabled: filterOpened,
  });

  const filterConfig: FilterRecord = {
    date_range: {
      type: "date_range_preset",
      label: "Time Interval",
      childKeys: ["date_range", "startDate", "endDate"],
      options: REPORT_TIME_INTERVAL_OPTIONS,
    },
    provider_Name: {
      type: "select",
      label: "Provider",
      placeholder: "All Provider",
      options:
        providersList?.data?.content?.map((p: any) => ({
          value: p?.uuid,
          label: p?.name,
        })) ?? [],
      onSearch: (val: string) => setSearchProviderKey(val),
    },
    location: {
      type: "select",
      label: "Location",
      placeholder: "All Locations",
      options:
        locationsList?.data?.map((l: any) => ({
          value: l?.uuid,
          label: l?.name ?? l?.locationName,
        })) ?? [],
      onSearch: (val: string) => setSearchLocationKey(val),
    },
    claim_Status: {
      type: "select",
      label: "Status",
      placeholder: "All Statuses",
      options: BILLING_STATUS_OPTIONS,
    },
    insurance: {
      type: "select",
      label: "Insurance",
      placeholder: "Search Insurance",
    },
  };

  const activeFilterCount = useActiveComponentCountController(
    filters as unknown as Record<string, unknown>
  );

  return (
    <div onClick={() => !filterOpened && setFilterOpened(true)}>
      <FilterBuilderV2
        filters={filterConfig}
        onApply={onApply}
        prefillValues={filters}
        activeFilterCount={activeFilterCount}
      />
    </div>
  );
};

export default BillingReportFilters;
